import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage as FM } from 'react-intl';
import classNames from 'classnames';

import Phone from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { withTheme } from 'common/styling/theme';
import { staticStyles, getDynamicStyles } from './style';

const PhoneFormField = ({ input, disabled = false, meta: { touched, active, error }, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  return (
    <div className={classNames('PhoneFormField', { error: touched && error }, { PhoneFormField__disabled: disabled })}>
      <div>
        <FM id="justPhone">{() => <Phone {...input} disabled={disabled} />}</FM>
        <label
          className={classNames('PhoneFormField__label', { active }, { haveText: input.value })}
          htmlFor={input.name}>
          <FM id="justPhone" />
        </label>
      </div>
      <span className="PhoneFormField__error">{touched && error}</span>
      <style jsx global>
        {staticStyles}
      </style>
      <style jsx global>
        {dynamicStyles}
      </style>
    </div>
  );
};

PhoneFormField.propTypes = {
  input: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    active: PropTypes.bool.isRequired,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  }).isRequired,
  theme: PropTypes.object,
};

PhoneFormField.defaultProps = {
  disabled: false,
  theme: {},
};

export default withTheme()(PhoneFormField);
